import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../common/components/functional/customButton/CustomButton";
import { canExpertEditTalentProfile } from "../../user/accessRightChecks";
import { HrExpertUser } from "../../user/types/entities";

type Props = {
  hrRep?: HrExpertUser;
  isLoading: boolean;
  setShowEditModal: (show: boolean) => void;
  disableEdit: boolean;
};

const getHrRepName = (hrRep: HrExpertUser) =>
  `${hrRep?.firstName} ${hrRep?.lastName}`;

const TalentHrRepresentative = ({
  hrRep,
  isLoading,
  setShowEditModal,
  disableEdit,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <Box
      display="flex"
      gap="8px"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
        {!hrRep && !isLoading && (
          <Typography lineHeight="16.8px">{t("hrExpertMissing")}</Typography>
        )}
        {hrRep && (
          <Box display="flex" gap="8px" alignItems="center" flexWrap="wrap">
            <Typography lineHeight="16.8px">{getHrRepName(hrRep)}</Typography>
            <Typography
              variant="secondary"
              whiteSpace="nowrap"
              lineHeight="16.8px"
            >
              {hrRep?.eezyCompanyNames.join(", ") || ""}
            </Typography>
          </Box>
        )}
        <CustomButton
          accessRightChecks={[canExpertEditTalentProfile, !disableEdit]}
          onClick={() => setShowEditModal(true)}
          variant="text"
          sx={{
            height: "16.8px",
            padding: 0,
            "&:hover": { backgroundColor: "transparent" },
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {t("changeMyHr")}
          </Typography>
        </CustomButton>
    </Box>
  );
};

export default TalentHrRepresentative;
